export const seo = {
    // route: '/',
    position: 6,
    name: 'SEO Settings',
    fields: [],
};
